export const processProposedTreatment = (proposedTreatment = []) => {
  return [...proposedTreatment]
    .filter((treat) => {
      // Check if treatment has meaningful data
      const hasImportantData = treat?.degradation || treat?.temp_id;

      const noDataPropose =
        treat?.step &&
        treat?.action === "" &&
        treat?.is_completed === false &&
        treat?.task === "" &&
        treat?.status === "" &&
        !hasImportantData;

      return !noDataPropose; // keep only treatments with real data
    })
    .map((treat) => {
      const filteredLogs = [...(treat?.treatment_log || [])]
        .filter((log) => {
          const hasEvidence = (log?.evidence || []).some(
            (img) => img?.image?.trim() || img?.thumbnail?.trim()
          );

          // keep only if at least one field has data
          return log?.date?.trim() || log?.notes?.trim() || hasEvidence;
        })
        .map((log) => ({
          ...log,
          evidence: [...(log?.evidence || [])]
            .filter((img) => img?.image?.trim() || img?.thumbnail?.trim()) // filter empty images
            .reverse(),
        }))
        .reverse();

      return {
        ...treat,
        treatment_log: filteredLogs, // always keep the key, even if []
      };
    })
    .reverse(); // reverse tre
};

export const processStratigraphic = (stratigraphic = []) => {
  return [...stratigraphic]
    .map((layer) => {
      // filter & reverse details
      const filteredDetails = [...(layer?.assessment_details || [])]
        .filter((detail) => {
          return (
            detail?.description?.trim() ||
            detail?.location?.trim() ||
            detail?.details?.trim() ||
            detail?.degradation?.trim() ||
            (detail?.evidence_images || []).some((img) => img?.image?.trim())
          );
        })
        .map((detail) => ({
          ...detail,
          evidence_images: [...(detail?.evidence_images || [])]
            .filter((img) => img?.image?.trim())
            .reverse(),
        }))
        .reverse();

      return {
        ...layer,
        assessment_details: filteredDetails,
      };
    })
    .filter((layer) => {
      const hasDetails = (layer?.assessment_details || []).length > 0;

      const hasOtherData =
        !!layer?.assessment_name ||
        !!layer?.assessment_materials ||
        !!layer?.assessment_stability ||
        layer?.assessment_is_emergency === true;

      // ❌ remove ONLY if no details AND no other meaningful data
      return hasDetails || hasOtherData;
    })
    .reverse();
};

export const filterInvestigationDetails = (investigationDetails = []) => {
  if (!Array.isArray(investigationDetails)) return [];

  return investigationDetails
    .filter((item) => {
      return (
        item?.investigation_name?.trim() ||
        item?.result?.trim() ||
        item?.sample_details?.trim()
      );
    })
    .reverse();
};

export const filterGraphicalRepresentation = (graphicalRepresentation = []) => {
  if (!Array.isArray(graphicalRepresentation)) return [];

  const filtered =
    graphicalRepresentation.filter((item) => item?.image).reverse() || [];

  return filtered;
};

const isMeaningfulValue = (value) => {
  if (value === null || value === undefined) return false;

  // ❌ booleans never trigger status
  if (typeof value === "boolean") return false;

  // ✅ strings
  if (typeof value === "string") return value.trim() !== "";

  // ✅ numbers (optional – keep if needed)
  if (typeof value === "number") return true;

  // ❌ objects & arrays handled separately
  return false;
};

const IGNORED_FIELDS = [
  "remarks",
  "stability",
  "is_emergency",
  "object_details",
  "id",
  "conservation_is_draft",
  "session",
];

export const hasOtherFieldValue = (values = {}) => {
  // ✅ backend-safe array checks
  const hasValidStratigraphic =
    Array.isArray(values?.stratigraphic_assessment) &&
    processStratigraphic(values.stratigraphic_assessment).length > 0;

  const hasValidGraphicalRepresentation =
    Array.isArray(values?.graphical_represenatation) &&
    filterGraphicalRepresentation(values.graphical_represenatation).length > 0;

  const hasValidProposedTreatment =
    Array.isArray(values?.proposed_treatment) &&
    processProposedTreatment(values.proposed_treatment).length > 0;

  const hasValidInvestigationDetails =
    Array.isArray(values?.investigation_details) &&
    filterInvestigationDetails(values.investigation_details).length > 0;

  if (
    hasValidProposedTreatment ||
    hasValidInvestigationDetails ||
    hasValidStratigraphic ||
    hasValidGraphicalRepresentation
  ) {
    return true;
  }

  // ✅ strict primitive checks
  return Object.keys(values).some((key) => {
    if (
      IGNORED_FIELDS.includes(key) ||
      [
        "proposed_treatment",
        "investigation_details",
        "graphical_represenatation",
        "stratigraphic_assessment",
      ].includes(key)
    ) {
      return false;
    }

    return isMeaningfulValue(values[key]);
  });
};
